// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-404-container[data-v-53853d67]{position:relative;width:100vw;height:100vh}.error-404-container .error-content[data-v-53853d67]{position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);text-align:center}.error-404-container .error-content .title[data-v-53853d67]{font-weight:500;font-size:16px;color:#7f8596}.error-404-container .error-content .link[data-v-53853d67]{display:inline-block;margin-top:10px;font-weight:500;font-size:16px;color:#4066d4}", ""]);
// Exports
module.exports = exports;
